module.exports = "\n<div class=\"comp-popup-countries-map\">\n  <popup-content :popup-key=\"popupKey\" mode=\"modal\" show-close-button=\"true\" v-on:click-backdrop=\"hide\" v-on:click-close=\"hide\" close-text=\"Karte schließen\">\n    <countries-map :active_country_codes=\"payload.active_country_codes\" :country_links=\"payload.country_links\" :zoom_state=\"payload.zoom_state\" :center_lat=\"payload.center_lat\" :center_lng=\"payload.center_lng\" interactive=\"true\"></countries-map>\n  </popup-content>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./assets/js/frontend/components/popup_countries_map/index.pug
// module id = 648
// module chunks = 4